import React, { useState, useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import isEmail from 'validator/lib/isEmail';
import { Drawer, Button, TextInputWithLabel } from 'quantux-ui';

import { BASE_URL } from '../../utils';
import { gray, blue, salmon } from '../../theme';

const payerIconSmall = (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Zm12.073-2L3.502 4.857v8.571A8.57 8.57 0 0 0 12.073 22a8.57 8.57 0 0 0 8.571-8.572V4.857L12.073 2Zm0 18.393a6.965 6.965 0 0 0 6.965-6.965V6.063l-6.964-2.455-6.965 2.455v7.366a6.965 6.965 0 0 0 6.965 6.965Z"
      fill="#00A0FF"
    />
  </svg>
);

const payerIcon = (
  <svg
    width="64"
    height="64"
    style={{ minWidth: '64px', minHeight: '64px' }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4a4 4 0 0 1 4-4h56a4 4 0 0 1 4 4v56a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Zm32.195 1.333L9.337 12.952v22.857c0 12.625 10.233 22.857 22.858 22.857S55.052 48.434 55.052 35.81V12.952l-22.857-7.62Zm.001 49.048c10.256 0 18.572-8.316 18.572-18.572V16.166L32.196 9.62l-18.571 6.547V35.81c0 10.256 8.316 18.572 18.571 18.572Z"
      fill="#00A0FF"
    />
  </svg>
);

const AddPayerDrawer = (props) => {
  const [payerName, setPayerName] = useState('');
  const [payerUsername, setPayerUsername] = useState('');
  const [isPayerUserNamePristine, setIsPayerUserNamePristine] = useState(true);
  const [isPayerUserNameValid, setIsPayerUserNameValid] = useState(true);
  const [isPayerUserNameDuplicate, setIsPayerUserNameDuplicate] = useState(true);
  const [payerCode, setPayerCode] = useState('');
  // --
  const [payerStreetAddress, setPayerStreetAddress] = useState('');
  const [payerSuite, setPayerSuite] = useState('');
  const [payerCity, setPayerCity] = useState('');
  const [payerState, setPayerState] = useState('');
  const [payerZip, setPayerZip] = useState('');
  // --
  const [payerPhone, setPayerPhone] = useState('')
  const [isPayerPhonePristine, setIsPayerPhonePristine] = useState(true);
  const [isPayerPhoneValid, setIsPayerPhoneValid] = useState(true);
  const [payerFax, setPayerFax] = useState('');
  const [payerWebsite, setPayerWebsite] = useState('');
  const [payerEmail, setPayerEmail] = useState('');
  const [isPayerEmailPristine, setIsPayerEmailPristine] = useState(true);
  const [isPayerEmailValid, setIsPayerEmailValid] = useState(true);
  const [canAddPayer, setCanAddPayer] = useState(false);

  const styles = StyleSheet.create({
    drawerContainer: {
      background: gray[800],
      color: gray[300],
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    drawerHeader: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      fontWeight: 'bold',
      borderBottom: '1px solid black',
      flexShrink: '0'
    },
    drawerHeaderCloseIcon: {
      color: gray[300],
      ':hover': {
        color: salmon[500]
      }
    },
    drawerBanner: {
      position: 'relative',
      padding: '8px',
      flexShrink: '0'
    },
    drawerBannerImg: {
      width: '100%',
      height: 'auto'
    },
    drawerBannerCameraIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      right: '0',
      bottom: '8px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerContentArea: {
      // height: 'calc(100vh - 186px)',
      overflowY: 'auto',
      color: gray[300],
      flexGrow: '1'
    },
    drawerUserCardAvatar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      // background: blue[500],
      color: 'white',
      borderRadius: '4px',
      position: 'relative'
    },
    drawerUserCardAvatarImg: {
      width: 'auto',
      height: '80px',
      maxHeight: '80px'
    },
    drawerAvatarCamera: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      left: '-3px',
      top: '58px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerUserCardText: {
      fontSize: '12px'
    },
    profileTextAreaContainer: {
      paddingRight: '8px'
    },
    profileTextArea: {
      width: '100%',
      background: gray[900],
      height: '100px',
      color: gray[100],
      border: 'none',
      resize: 'none',
      overflow: 'auto',
      fontFamily: 'Lato',
      padding: '8px',
      ':focus': {
        outlineColor: 'transparent',
        outlineStyle: 'none'
      }
    },
    drawerFooter: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      background: gray[700],
      height: '56px',
      width: '100%',
      borderTop: `1px solid ${gray[500]}`,
      // position: 'absolute',
      // top: 'calc(100vh - 56px)',
      flexShrink: '0'
    }
  });

  const {
    isOpen,
    payerBannerImageUrl = 'https://quantumtrader.s3.amazonaws.com/defaultBanner.svg',
    payerAvatarImageUrl = '',
    onClose,
    onClickBannerCamera,
    onClickAvatarCamera,
    onReloadData,
    zIndex
  } = props;

  // Initial Payer Name Search -- from the insurance drawer
  useEffect(() => {
    setPayerName(props.payerName || '');
  }, [props.payerName])

  // Payer useranme validity and duplicate check
  useEffect(() => {
    const isValid = payerUsername.length >= 2 && payerUsername.length <= 20 && payerUsername.indexOf(' ') < 0;
    setIsPayerUserNameValid(isValid);
    setCanAddPayer(!isPayerUserNameDuplicate && isPayerUserNameValid && payerName.length >= 2);
    if (isValid) {
      const formData = new FormData();
      // formData.append('id', props.data._id);
      formData.append('newUsername', payerUsername);

      const reqHeaders = new Headers();
      const token = localStorage.getItem('token');
      reqHeaders.append('Authorization', `Bearer ${token}`);
      const requestOptions = {
        method: 'POST',
        body: formData,
        redirect: 'follow',
        headers: reqHeaders
      };

      fetch(`${BASE_URL}/payers2/checkUniqueUsername`, requestOptions)
        .then(response => response.text())
        .then(result => {
          const res = JSON.parse(result);
          // console.log(res);
          if (res.success) {
            setIsPayerUserNameDuplicate(res.isDuplicate);
            setCanAddPayer(!res.isDuplicate && isPayerUserNameValid && payerName.length >= 2);
          } else {
            setIsPayerUserNameDuplicate(true);
          }
        })
        .catch(error => {
          console.log('error', error);
        });
    }
  }, [payerUsername]);

  // Payer email validity check
  useEffect(() => {
    const isValidEmail = isEmail(payerEmail);
    setIsPayerEmailValid(isValidEmail);
    // setCanAddPayer(!isPayerUserNameDuplicate && isPayerUserNameValid && isValidEmail && payerName.length >= 2);
  }, [payerEmail]);

  useEffect(() => {
    setCanAddPayer(!isPayerUserNameDuplicate && isPayerUserNameValid && payerName.length >= 2);
  }, [payerName]);

  const handleOnEditPayerName = (e) => {
    const { value } = e.target;
    setPayerName(value);
  };

  const handleOnEditUserName = (e) => {
    const { value } = e.target;
    setPayerUsername(value);
    setIsPayerUserNamePristine(false);
  };

  const handleOnEditStreetAddress = (e) => {
    const { value } = e.target;
    setPayerStreetAddress(value);
  };

  const handleOnEditSuite = (e) => {
    const { value } = e.target;
    setPayerSuite(value);
  };

  const handleOnEditCity = (e) => {
    const { value } = e.target;
    setPayerCity(value);
  };

  const handleOnEditState = (e) => {
    const { value } = e.target;
    setPayerState(value);
  };

  const handleOnEditZip = (e) => {
    const { value } = e.target;
    setPayerZip(value);
  };

  const handleOnEditPhone = (e) => {
    const { value } = e.target;
    setPayerPhone(value);
  };

  const handleOnEditFax = (e) => {
    const { value } = e.target;
    setPayerFax(value);
  };

  const handleOnEditWesbite = (e) => {
    const { value } = e.target;
    setPayerWebsite(value);
  };

  const handleOnEditEmail = (e) => {
    const { value } = e.target;
    setPayerEmail(value);
    setIsPayerEmailPristine(false);
  };

  const handleOnEditPayerCode = (e) => {
    const { value } = e.target;
    setPayerCode(value);
  };

  const handleOnClickAddPayer = () => {
    const formData = new FormData();
    formData.append('payerName', payerName);
    formData.append('payerAvatarImageUrl', payerAvatarImageUrl);
    formData.append('payerBannerImageUrl', payerBannerImageUrl);
    formData.append('userName', payerUsername);
    formData.append('payerId', payerCode);
    formData.append('streetAddress', payerStreetAddress.trim());
    formData.append('suite', payerSuite.trim());
    formData.append('city', payerCity.trim());
    formData.append('state', payerState.trim());
    formData.append('zip', payerZip.trim());
    // Payer Phone
    let phone = payerPhone.startsWith('1') ? payerPhone.substring(1) : payerPhone;
    phone = phone.replace(/-/g, '');
    formData.append('phone', phone);
    // Payer Fax
    let fax = payerFax.startsWith('1') ? payerFax.substring(1) : payerFax;
    fax = fax.replace(/-/g, '');
    formData.append('fax', fax);
    // Payer Email & Website
    formData.append('email', payerEmail);
    formData.append('website', payerWebsite);

    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(`${BASE_URL}/payers2/addPayerProfile`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        if (res.success) {
          onReloadData();
        }
      })
      .catch(error => {
        console.log('error', error);
      });
  };

  return (
    <Drawer
      placement="right"
      visible={isOpen}
      toggleDrawer={onClose}
      zIndex={props.zIndex}
      showMask={props.showMask}
      width={window.innerWidth <= 700 ? window.innerWidth : 375}
    >
      <div className={css(styles.drawerContainer)}>
        {/* Header */}
        <div className={css(styles.drawerHeader)}>
          <div className='fx fx__hv-center'>
            {payerIconSmall}
            <div className='ml-2'>Payer Profile</div>
          </div>
          <i
            className={`fa fa-lg fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
            onClick={onClose}
          />
        </div>
        {/* Drawer Contents */}
        <div className={css(styles.drawerContentArea)}>
          {/* Banner */}
          <div className={css(styles.drawerBanner)}>
            <img
              src={payerBannerImageUrl}
              alt="cropped-banner"
              className={css(styles.drawerBannerImg)}
            />
            {/* Camera icon */}
            <div
              className={css(styles.drawerBannerCameraIcon)}
              onClick={onClickBannerCamera}
            >
              <i className="fa fa-camera" />
            </div>
          </div>
          {/* Middle area */}
          <div className={css(styles.drawerContentArea)}>
            {/* User card */}
            <div className="fx ml-2">
              {/* Avatar */}
              <div className={css(styles.drawerUserCardAvatar)}>
                {payerAvatarImageUrl && payerAvatarImageUrl.length > 0
                  ? <img
                    src={payerAvatarImageUrl}
                    alt="avatar"
                    className={css(styles.drawerUserCardAvatarImg)}
                    onClick={onClickAvatarCamera}
                  />
                  : payerIcon
                }
                <div
                  onClick={onClickAvatarCamera}
                  className={css(styles.drawerAvatarCamera)}
                >
                  <i className="fa fa-camera" />
                </div>
              </div>
              {/* User card displayName & userName */}
              <div className={`ml-2 ${css(styles.drawerUserCardText)}`}>
                {/* Payer Name */}
                <div style={{ fontSize: '12px', color: gray[200], lineHeight: '12px', paddingLeft: '2px', marginTop: '-4px' }}>
                  {/* {payerName !== '' ? payerName : ''} */}
                  <TextInputWithLabel
                    value={payerName}
                    titleText="Payer Name"
                    titleFontSize={12}
                    isCompactLayout={true}
                    titleColor={gray[200]}
                    textColor={blue[500]}
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={266}
                    placeholder='Required'
                    onChange={handleOnEditPayerName}
                  />
                </div>
                {/* Payer Username */}
                <div>
                  <TextInputWithLabel
                    value={payerUsername}
                    titleText="Username (2 to 20 characters, no spaces)"
                    titleFontSize={12}
                    isCompactLayout={true}
                    titleColor={gray[200]}
                    textColor={blue[500]}
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={266}
                    placeholder='Required'
                    onChange={handleOnEditUserName}
                  />
                  {/* Error message */}
                  {!isPayerUserNameValid && !isPayerUserNamePristine
                    ? <div
                      style={{
                        color: '#FF6060',
                        fontSize: '12px'
                      }}
                    >
                      Invalid User Name
                    </div>
                    : null
                  }
                  {!isPayerUserNamePristine && isPayerUserNameDuplicate && isPayerUserNameValid
                    ? <div
                      style={{
                        color: '#FF6060',
                        fontSize: '12px'
                      }}
                    >
                      User Name Taken
                    </div>
                    : null
                  }
                </div>
              </div>
            </div>
            {/* Payer ID/Code */}
            <div className='ml-2 mt-4'>
              <TextInputWithLabel
                value={payerCode}
                titleText="Payer Code"
                titleFontSize={12}
                isCompactLayout
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={353}
                onChange={handleOnEditPayerCode}
              />
            </div>
            {/* Middle area */}
            <div className="ml-2" style={{ marginTop: '32px' }}>
              {/* Mailing address heading */}
              <div className="fx fx__v-center">
                <i className="fa fa-map-marker" style={{ fontSize: '28px' }} />
                <div className="ml-2">
                  Address
                </div>
              </div>
              {/* Form */}
              <div>
                {/* Street address & suite */}
                <div className="fx">
                  <div>
                    <TextInputWithLabel
                      value={payerStreetAddress}
                      titleText="Street"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={300}
                      onChange={handleOnEditStreetAddress}
                    />
                  </div>
                  <div className="ml-2">
                    <TextInputWithLabel
                      value={payerSuite}
                      titleText="Suite"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={45}
                      onChange={handleOnEditSuite}
                    />
                  </div>
                </div>
                {/* City, State and Zip */}
                <div className="fx mt-2">
                  <div>
                    <TextInputWithLabel
                      value={payerCity}
                      titleText="City"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={246}
                      onChange={handleOnEditCity}
                    />
                  </div>
                  <div className="ml-2">
                    <TextInputWithLabel
                      value={payerState}
                      titleText="State"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={45}
                      onChange={handleOnEditState}
                    />
                  </div>
                  <div className="ml-2">
                    <TextInputWithLabel
                      value={payerZip}
                      titleText="Zip"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={45}
                      onChange={handleOnEditZip}
                    />
                  </div>
                </div>
                {/* Phone */}
                <div className="mt-2">
                  <TextInputWithLabel
                    value={payerPhone}
                    titleText="Phone"
                    titleFontSize={12}
                    titleColor={gray[200]}
                    textColor="white"
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={353}
                    onChange={handleOnEditPhone}
                    // isCompactLayout={false}
                    // showPreIcon
                    // preIcon='fa fa-phone'
                  />
                  {!isPayerPhonePristine && !isPayerPhoneValid
                    ? <div className={css(styles.errMsg)}>Invalid Phone #</div>
                    : null
                  }
                </div>
                {/* Fax */}
                <div className="mt-2">
                  <TextInputWithLabel
                    value={payerFax}
                    titleText="Fax"
                    titleFontSize={12}
                    titleColor={gray[200]}
                    textColor="white"
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={353}
                    onChange={handleOnEditFax}
                    // isCompactLayout={false}
                    // showPreIcon
                    // preIcon='fa fa-fax'
                  />
                </div>
                {/* Website */}
                <div className="mt-2">
                  <TextInputWithLabel
                    value={payerWebsite}
                    titleText="Website"
                    titleFontSize={12}
                    titleColor={gray[200]}
                    textColor="white"
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={353}
                    onChange={handleOnEditWesbite}
                    // isCompactLayout={false}
                    // showPreIcon
                    // preIcon='fa fa-globe'
                  />
                </div>
                {/* Email */}
                <div className="mt-2">
                  <TextInputWithLabel
                    value={payerEmail}
                    titleText="Email"
                    titleFontSize={12}
                    titleColor={gray[200]}
                    textColor="white"
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={353}
                    onChange={handleOnEditEmail}
                    // isCompactLayout={false}
                    // showPreIcon
                    // preIcon='fa fa-globe'
                  />
                  {!isPayerEmailPristine && !isPayerEmailValid
                    ? <div className={css(styles.errMsg)}>Invalid Email</div>
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className={`fx pr-2 ${css(styles.drawerFooter)}`} >
          <Button
            btnType="primary"
            isDisabled={!canAddPayer}
            className="fx fx__hv-center"
            onClick={handleOnClickAddPayer}
            style={{
              height: '32px',
              width: '340px',
              padding: '3px 0'
            }}
          >
            Create Payer Profile
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

AddPayerDrawer.defaultProps = {
  zIndex: '2000',
  showMask: 'true'
};

export default AddPayerDrawer;
